(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avis-boutique"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-prev], [data-next]');
  if (!btn) return;
  var root = btn.closest('[class*="jbcar-"]');
  if (!root) return;
  var track = root.querySelector('[data-track]');
  if (!track) return;
  var card = track.querySelector('.jbcar__card');
  var step = card ? card.offsetWidth + 20 : track.clientWidth * 0.8;
  track.scrollBy({ left: btn.hasAttribute('data-prev') ? -step : step, behavior: 'smooth' });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
